<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品物料设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 产品数据信息表格 -->
      <el-table :data="productMessageList">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column label="产品名称" prop="ProductName" width="150px" align="center"></el-table-column>
        <el-table-column label="产品编号" prop="ProductCode" width="150px" align="center"></el-table-column>
        <el-table-column label="产品类型" prop="TypeName" align="center"></el-table-column>
        <el-table-column label="规格型号" prop="Spec" width="120px" align="center"></el-table-column>
        <el-table-column label="单位" prop="Unit" width="120px" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" size="mini" @click="showMateria(scope)">设置物料</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 显示物料类型信息的会话框 -->
    <el-dialog title="设置物料" :visible.sync="editDialogVisible" width="50%" @close="editDialogClose">
      <div class="test1">
        <h3 class="H3">选择物料:</h3>
        <el-select v-model="materialSetID" size="mini" placeholder="请选择要添加的物料">
          <el-option v-for="item in materialist" :key="item.ID" :label="item.MaterialName" :value="item.ID">
          </el-option>
        </el-select>
        <div class="button1">
          <el-button type="primary" size="mini" @click="editProduct()">确 定</el-button>
        </div>
      </div>
      <el-table :data="product_MateriaList" border stripe @selection-change="handleSelectionChange" ref="materiaID">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column label="物料名称" prop="MaterialName" align="center"></el-table-column>
        <el-table-column label="物料编号" prop="MaterialCode" width="120px"align="center"></el-table-column>
        <el-table-column label="规格型号" prop="Spec" width="120px"align="center"></el-table-column>
        <el-table-column label="单位" prop="Unit" width="120px"align="center"></el-table-column>
        <el-table-column label="备注" prop="Remark"align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" size="mini" @click="deleteSetMateria(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="sedium" @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="sedium" @click="editDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '10',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            // 查询参数对象
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 10
            },
            // 产品信息表
            productMessageList: [],
            // 物料信息表
            materialist: [],
            // 选中的物料信息
            materialSetID: '',
            // 产品关联物料信息表
            product_MateriaList: [],
            // 总数据条数
            total: 0,
            // 控制修改信息对话框的显示与隐藏
            editDialogVisible: false,
            // 控制添加信息对话框的显示与隐藏
            addDialogVisible: false,
            // 编辑用户信息的表单
            editForm: {},
            // 修改表单的验证规则对象
            editFormRules: {
                TypeName: [
                    { required: true, message: '请输入类型', trigger: 'blur' },
                ],
                CreateUser: [
                    { required: true, message: '请输入创建人', trigger: 'blur' },
                ]
            },
            // 产品物料绑定接口请求所需
            bindList: {
                // 产品标识符
                ProductSet_ID: '',
            },
            testList: {
                page: '1',
                limit: '100',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                ID: ''
            },
            //获取到的物料ID
            materiaID: {
            },
            CreateTime: '2023-05-10T17:59:28.000+0000',
            Remark: '',
            allNumber: ''
        }
    },
    created () {
        this.getProductMessage()
        this.getMateria()
        this.getTest()
    },
    methods: {
        // 调用接口获取产品信息
        async getProductMessage () {
            const { data: res } = await this.$http.get('/WMS/queryProducRelate', { params: this.getTypeList })
            // console.log('8888888')
            // console.log(res)
            this.productMessageList = res.data
        },
        // 展示显示物料的对话框
        async showMateria (scope) {
            this.editDialogVisible = true
            // 调用接口获取本行产品信息
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            // console.log('0809' + params)
            const { data: res } = await this.$http.get('/WMS/queryProductSetID', { params })
            this.bindList.ProductSet_ID = res.data[0].ID
            this.testList.ID = res.data[0].ID
            // console.log(this.bindList.ProductSet_ID)
            // console.log('888999' + this.testList.ID)
            // 根据产品id查询关联物料信息
            this.getMateriaByID()
        },
        //  监听添加信息对话框的关闭事件
        addDialogClosed () {
            this.$refs.addFormRef.resetFields()
        },
        // 调用接口绑定产品与物料
        async editProduct () {
            // if (this.allNumber >= 3) {
            //     return this.$message.error('该产品已绑定三种类型物料，请勿重复绑定！')
            // }
            let params = new URLSearchParams();
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("ProductSet_ID", this.bindList.ProductSet_ID)
            params.append("MaterialSet_ID", this.materialSetID)
            // console.log('0000' + params)
            const { data: res } = await this.$http.post('/WMS/InsertProducMaterial', params)
            // console.log(res)
            if (res == -3) {
                return this.$message.error('重复绑定！')
            }
            if (res == -4) {
                return this.$message.error('请选择要绑定的物料！')
            }
            if (res == -5) {
                return this.$message.error('设置物料失败，关联物料场次必须相同！')
            }
            if (res == -6) {
                return this.$message.error('设置物料失败，物料产品类型重复！')
            }
            if (res !== 1) {
                return this.$message.error('设置物料失败！')
            }
            this.getMateriaByID()
            // 提示修改成功
            this.$message.success('设置物料成功！')
        },
        // 调用接口获取物料信息
        async getMateria () {
            let params = new URLSearchParams();
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/queryMaterialsetOne', { params })
            console.log("🚀 ~ getMateria ~ res:", res)
            this.materialist = res.data
        },
        handleSelectionChange () {
            // console.log(1111)
            // console.log(this.$refs.materiaID.selection);
            // console.log('123' + this.$refs.materiaID.selection.map((item) => item.ID))
            this.materiaID = this.$refs.materiaID.selection.map((item) => item.ID)
            // console.log(this.materiaID)
        },
        // 根据产品id查询关联物料信息
        async getMateriaByID () {
            const { data: res } = await this.$http.get('/WMS/queryProducIDMaterial', { params: this.testList })
            // console.log(2222222)
            // console.log(res.data)
            // console.log(res.count)
            // if (res.count < 3) {
            //     this.$message.error('请选择三种物料！')
            // }
            this.allNumber = res.count
            this.product_MateriaList = res.data
        },
        //调用接口获取产品物料关联信息
        async getTest () {
            const { data: res } = await this.$http.get('/WMS/queryProducMaterial', { params: this.getTypeList })
            // console.log(111111111)
            // console.log(res.data)
        },
        // 调用接口删除产品相关物料
        async deleteSetMateria (scope) {

            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            // console.log('=======')
            // console.log('000' + params)
            const { data: res } = await this.$http.post('/WMS/deleteProducMaterial', params)
            // console.log(res)
            this.getMateriaByID()
        },
        // // 根据ID查询产品物料关联数据
        // async queryProducMateriaByID (ID) {
        //     let params = new URLSearchParams();
        //     params.append("ID", ID)
        //     params.append("privateKey", this.getTypeList.privateKey)
        //     params.append("appIdentification", this.getTypeList.appIdentification)
        //     const { data: res } = await this.$http.get('/deleteProductType', { params })
        //     console.log('+++++++++')
        //     console.log(res.data)
        // }
        editDialogClose() {},
    }
}
</script>

<style lang="less" scoped>
.test1 {
  display: flex;
}
.H3 {
  font-weight: 700;
  transform: translateY(-50%); /**上移元素**/
  -ms-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  margin-right: 10px;
}
.button1 {
  transform: translateX(15%); /**右移元素**/
  -ms-transform: translateX(15%);
  -webkit-transform: translateX(15%);
}
</style>
